import cables from "./jsons/cables.json";

export const division_mock = [
  { div_code: "PRYJ", total_asset_cnt: 1270, pf_cnt: 8, fl_cnt: 199, mf_cnt: 10, mo_cnt: 13 },
  { div_code: "JHS", total_asset_cnt: 350, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { div_code: "AGC", total_asset_cnt: 500, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { div_code: "AGC", total_asset_cnt: 500, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
];
export const station_mock = [
  { stn_code: "MIU", total_asset_cnt: 350, pf_cnt: 8, fl_cnt: 199, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "DER", total_asset_cnt: 355, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "AJR", total_asset_cnt: 530, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "WIR", total_asset_cnt: 520, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "DKDE", total_asset_cnt: 580, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "CHL", total_asset_cnt: 580, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "SHK", total_asset_cnt: 580, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "KRJ", total_asset_cnt: 580, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "DAR", total_asset_cnt: 580, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "SOM", total_asset_cnt: 580, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "KLA", total_asset_cnt: 580, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
  { stn_code: "MWUE", total_asset_cnt: 580, pf_cnt: 8, fl_cnt: 9, mf_cnt: 10, mo_cnt: 13 },
];

export const mock_parsed_data = {
  division_wise: {
    PRYJ: {
      div_code: "PRYJ",
      pf_cnt: 0,
      fl_cnt: 1,
      mf_cnt: 1,
      mo_cnt: 6,
      total_asset_cnt: 144,
    },
    JHS: {
      div_code: "JHS",
      pf_cnt: 1,
      fl_cnt: 2,
      mf_cnt: 1,
      mo_cnt: 4,
      total_asset_cnt: 130,
    },
    AGC: {
      div_code: "AGC",
      pf_cnt: 0,
      fl_cnt: 0,
      mf_cnt: 2,
      mo_cnt: 5,
      total_asset_cnt: 115,
    },
  },
  station_wise: {
    DER: {
      customer_name: "DER",
      pf_cnt: 0,
      fl_cnt: 1,
      mf_cnt: 1,
      mo_cnt: 3,
      total_asset_cnt: 86,
    },
    MIU: {
      customer_name: "MIU",
      pf_cnt: 0,
      fl_cnt: 0,
      mf_cnt: 0,
      mo_cnt: 3,
      total_asset_cnt: 58,
    },
    AJR: {
      customer_name: "AJR",
      pf_cnt: 0,
      fl_cnt: 1,
      mf_cnt: 1,
      mo_cnt: 1,
      total_asset_cnt: 64,
    },
    WIR: {
      customer_name: "WIR",
      pf_cnt: 0,
      fl_cnt: 0,
      mf_cnt: 1,
      mo_cnt: 2,
      total_asset_cnt: 52,
    },
    DKDE: {
      customer_name: "DKDE",
      pf_cnt: 0,
      fl_cnt: 0,
      mf_cnt: 0,
      mo_cnt: 3,
      total_asset_cnt: 48,
    },
    CHL: {
      customer_name: "CHL",
      pf_cnt: 0,
      fl_cnt: 1,
      mf_cnt: 1,
      mo_cnt: 2,
      total_asset_cnt: 61,
    },
  },
};

export const chart_parsed_data = [
  {
    customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "DER",
    software_id: "b50bdc0b-82dc-423f-afef-83ac4c978ef6",
    software_code: "OTHER",
    software_alias: "OTHER",
    last_alarm_created_dt: null,
    status: {
      total: 5,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "94d525de-0196-42dd-b787-441a6e0ed30a",
    software_code: "VoIP",
    software_alias: "VoIP",
    last_alarm_created_dt: null,
    status: {
      total: 5,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "f0644353-16ce-4b0e-b102-8a36fb22378c",
    software_code: "UTS-PRS",
    software_alias: "UTS-PRS",
    last_alarm_created_dt: null,
    status: {
      total: 6,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "DER",
    software_id: "c575cc67-354a-4a3a-b66a-7d902f1e4a7b",
    software_code: "SDH&PDH",
    software_alias: "SDH&PDH",
    last_alarm_created_dt: null,
    status: {
      total: 9,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
    software_code: "MTRC System",
    software_alias: "MTRC System",
    last_alarm_created_dt: null,
    status: {
      total: 7,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "7082da2e-b4f3-49c7-a2fb-d121d5e87fff",
    software_code: "SIP Exchange",
    software_alias: "SIP Exchange",
    last_alarm_created_dt: null,
    status: {
      total: 1,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "c575cc67-354a-4a3a-b66a-7d902f1e4a7b",
    software_code: "SDH&PDH",
    software_alias: "SDH&PDH",
    last_alarm_created_dt: null,
    status: {
      total: 7,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "a5e23c53-9b72-4af2-8f69-9e450cba5651",
    software_code: "Auto Exchange",
    software_alias: "Auto Exchange",
    last_alarm_created_dt: null,
    status: {
      total: 8,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "DER",
    software_id: "94d525de-0196-42dd-b787-441a6e0ed30a",
    software_code: "VoIP",
    software_alias: "VoIP",
    last_alarm_created_dt: null,
    status: {
      total: 5,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "881c306f-f230-4d56-910f-c3e66c83ace8",
    software_code: "DTMF",
    software_alias: "DTMF ",
    last_alarm_created_dt: null,
    status: {
      total: 6,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05986942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "PCOI",
    software_id: "98f1b640-e541-4cfb-bad0-0c453f26af80",
    software_code: "FMS",
    software_alias: "FMS",
    last_alarm_created_dt: null,
    status: {
      total: 1,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "b50bdc0b-82dc-423f-afef-83ac4c978ef6",
    software_code: "OTHER",
    software_alias: "OTHER",
    last_alarm_created_dt: null,
    status: {
      total: 2,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "cf2339e2-1e56-44f4-b896-fb48f1b7fe87",
    software_code: "VHF-SET",
    software_alias: "VHF-SET",
    last_alarm_created_dt: null,
    status: {
      total: 3,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "DER",
    software_id: "a5e23c53-9b72-4af2-8f69-9e450cba5651",
    software_code: "Auto Exchange",
    software_alias: "Auto Exchange",
    last_alarm_created_dt: null,
    status: {
      total: 10,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "DER",
    software_id: "ceb1b6ef-1c1c-4264-8af5-31ec9f533199",
    software_code: "RAILNET",
    software_alias: "RAILNET",
    last_alarm_created_dt: null,
    status: {
      total: 5,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05986942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "PCOI",
    software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
    software_code: "MTRC System",
    software_alias: "MTRC System",
    last_alarm_created_dt: null,
    status: {
      total: 1,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "9a4c39e3-bce2-492b-89be-9fba293df127",
    software_code: "SPT",
    software_alias: "SPT",
    last_alarm_created_dt: null,
    status: {
      total: 2,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "37b0e97a-e869-4647-b785-feee61f33503",
    software_code: "ETSR",
    software_alias: "ETSR",
    last_alarm_created_dt: null,
    status: {
      total: 4,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "a05d6713-4cc8-4480-9635-a6415efdf8ab",
    software_code: "Quad Cable ",
    software_alias: "Quad Cable",
    last_alarm_created_dt: null,
    status: {
      total: 5,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "DER",
    software_id: "f3d1f3ba-b167-4f16-a7e9-696f8c18d760",
    software_code: "MTRC System",
    software_alias: "MTRC System",
    last_alarm_created_dt: null,
    status: {
      total: 5,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    customer_name: "MIU",
    software_id: "ace6ab7c-ddbd-497c-82c6-2c599e14465b",
    software_code: "Magneto",
    software_alias: "Magneto",
    last_alarm_created_dt: null,
    status: {
      total: 2,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "DER",
    software_id: "37b0e97a-e869-4647-b785-feee61f33503",
    software_code: "ETSR",
    software_alias: "ETSR",
    last_alarm_created_dt: null,
    status: {
      total: 2,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "DER",
    software_id: "f0644353-16ce-4b0e-b102-8a36fb22378c",
    software_code: "UTS-PRS",
    software_alias: "UTS-PRS",
    last_alarm_created_dt: null,
    status: {
      total: 4,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "DER",
    software_id: "762fff69-6578-48fb-a108-49224905ec96",
    software_code: "IPIS System",
    software_alias: "IPIS System",
    last_alarm_created_dt: "2025-04-28T11:40:38.464+05:30",
    status: {
      total: 35,
      critical: 1,
      warning: 0,
      maintenance: 0,
    },
  },
  {
    customer_id: "05988942-ed90-4f89-8ab6-e22191ac9532",
    customer_name: "DER",
    software_id: "a05d6713-4cc8-4480-9635-a6415efdf8ab",
    software_code: "Quad Cable ",
    software_alias: "Quad Cable",
    last_alarm_created_dt: null,
    status: {
      total: 4,
      critical: 0,
      warning: 0,
      maintenance: 0,
    },
  },
];

export const geoJsonMap = {};

export const getCables = (counts = 10) => {
  const randomCount = Math.floor(Math.random() * (10 - 5 + 1)) + 5;
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        ...cables,
        // features: cables.features.slice(0, randomCount),
      });
    }, 500); // 500ms delay
  });
};


export function getLatLonFromAlarmPacket(rowData) {
  let lat = rowData?.update_value
    ? rowData?.update_value?.lat
    : rowData?.create_value?.lat;
  let lon = rowData?.update_value
    ? rowData?.update_value?.lon
    : rowData?.create_value?.lon;

  if (Number(lat) && Number(lon)) {
    return [ Number(lat), Number(lon)];
  } else {
    return null;
  }
}

export const nav_filter_severity_config = {
  fl: "CRITICAL",
  pf: "WARNING",
  mf: "MAINTENANCE_DEFICIENCY",
  mo: "MAINTENANCE_OVERDUE",
};
